import React, { Component } from "react";
import styles from "./trips.module.scss";
import LogisticAlatmTool from "../AlarmTools/LogisticAlatmTool";
import { states } from "../../../reducers/queriesStates";
import { withLogisticTrips } from "../../../shared/containers/containerLogisticTrips";

class TripAlarm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      errorTitle: null,
    };
  }

  componentDidUpdate(preProps) {
    const { logisticUpdateTripAlarmDataState, errors } = this.props;
    if (logisticUpdateTripAlarmDataState === states.FAILURE && preProps.logisticUpdateTripAlarmDataState === states.REQUEST) {
      const index = errors[0].data.indexOf("\n\r");
      const errorTile = errors[0].data.substring(0, index);
      this.setState({ errorTile });
    }
  }

  onUpdateAlarm(alarm) {
    const { onUpdateLogisticTripAlarm, logisticSelectedTrip } = this.props;
    this.setState({ errorTile: null });

    onUpdateLogisticTripAlarm(logisticSelectedTrip.id, alarm);
  }

  onCloseHandler() {
    const { onSetTripAlarmView } = this.props;
    onSetTripAlarmView(false);
  }

  render() {
    const { logisticSelectedTrip, logisticUpdateTripAlarmDataState } = this.props;
    const { errorTile } = this.state;

    return (
      <div className={styles.tripControlPointAlarmContainer}>
        <LogisticAlatmTool
          key={logisticSelectedTrip.id}
          title={`Рейс "${logisticSelectedTrip.title}"`}
          alarm={JSON.parse(JSON.stringify(logisticSelectedTrip.alarm))}
          withDays={true}
          onUpdateAlarm={this.onUpdateAlarm.bind(this)}
          errorTile={errorTile}
          isRequest={logisticUpdateTripAlarmDataState === states.REQUEST}
          onClose={this.onCloseHandler.bind(this)}
        />
      </div>
    );
  }
}

export default withLogisticTrips(React.memo(TripAlarm));
